/** 全局弹层层级：充值弹窗最高，Nav 入账 Toast 在导航之上、充值之下 */
export const Z_INDEX = {
  NAV: 200,
  /**
   * H5 右上角「更多 / 账户」侧栏（与 Element Plus 默认弹层起点同级）。
   * 须高于 Tawk 客服球；登录/福利等业务弹窗可与之同级或更高。
   */
  MOBILE_NAV_DRAWER: 2000,
  /** 登录/注册弹窗（须高于侧栏与 Tawk） */
  AUTH_DIALOG: 2100,
  /** PWA 安装引导条（高于底栏 Tab，低于业务弹窗） */
  PWA_INSTALL_BANNER: 580,
  /** 必要本地存储授权条（与 PWA 安装条同层，略高） */
  STORAGE_CONSENT_BANNER: 585,
  /** /pwa 拉新落地页弹层 */
  PWA_LANDING_DIALOG: 5900,
  /** 强制竖屏提示（盖住全站，含安装条） */
  PORTRAIT_LOCK: 9000,
  /** 本地存储不可用全屏引导（与竖屏锁同级） */
  STORAGE_BLOCKED: 9010,
  DEPOSIT_NAV_TOAST: 600,
  /** 交易下单弹窗 */
  TRADE_ORDER: 5100,
  /** 授权确认须盖在交易弹窗之上（快速卖出等场景） */
  TRADE_APPROVAL: 5200,
  /** 注册奖励弹窗（低于充值弹窗） */
  REGISTER_REWARD_DIALOG: 6120,
  /** 新用户福利金弹窗（与注册奖励同级） */
  TRIAL_FUND_DIALOG: 6120,
  /**
   * H5 Tawk 客服气泡（与 public/index.html DS_TAWK_Z_BUBBLE 同值）。
   * 高于底栏 / 下单 sticky(210–220)，低于：
   * 右上角侧栏(2000)、登录底栏、注册奖励/福利金弹窗、下单弹窗等。
   * Tawk 默认 ≈2e9，需 index.html 对祖先链反复压回。
   */
  TAWK_BUBBLE: 240,
  /**
   * Tawk 聊天面板展开（与 DS_TAWK_Z_CHAT 同值）。
   * 仍低于侧栏/登录(2000) 与业务弹窗；仅略高于页面 chrome。
   */
  TAWK_CHAT_PANEL: 1500,
  /** 从充值等弹窗内主动打开 Tawk 时盖过 DEPOSIT_DIALOG */
  TAWK_CHAT_OVER_DIALOG: 6400,
  /** H5 福利盘游戏式引导（日常层；运行时用 ABOVE_TAWK 盖住 Tawk） */
  TRIAL_FUND_GUIDE: 6150,
  /**
   * Tawk 默认 z-index ≈ 2e9，customStyle 常不生效；若尚未被压回，引导用此值盖住客服球再镂空。
   */
  TRIAL_FUND_GUIDE_ABOVE_TAWK: 2_000_000_100,
  /** 创建市场：流动性弹窗之上的余额不足提示 */
  CREATE_MARKET_ALERT: 6500,
  DEPOSIT_DIALOG: 6200,
  /** 充值赠送档位说明（盖在充值弹窗之上） */
  DEPOSIT_BONUS_BENEFITS: 6280,
  /** 充值/提现中国大陆地区限制提示（盖过账户页与底栏） */
  CHINA_REGION_ALERT: 6250,
  /** 邮箱新用户下单：充值 $1 激活体验金（须盖过交易弹窗） */
  TRIAL_ACTIVATE_DEPOSIT_ALERT: 5220,
  /** 法币充值教学视频：须盖在充值弹窗与其内嵌选择器之上 */
  FIAT_DEPOSIT_VIDEO_DIALOG: 6260,
  /** depositing 等场景下 Nav 需叠在充值弹窗之上 */
  DEPOSIT_NAV_TOAST_ABOVE_DIALOG: 6300,
  /** 体验金 / 奖励金到账文字弹窗（盖过业务弹窗，便于入账后立刻看到） */
  CREDIT_CLAIM_TOAST: 6450,
  /** 取消充值问卷（充值弹窗关闭后再出） */
  DEPOSIT_CANCEL_SURVEY: 6350,
};
